var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 188,
    viewBox: "0 0 189 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.972 60.8994H119.997C120.599 58.4919 121.201 56.0844 121.201 53.075C121.201 38.63 109.164 26.5925 94.7186 26.5925C80.2736 26.5925 68.2361 38.63 68.2361 53.075C68.2361 55.4825 68.838 58.4919 69.4399 60.8994H13.4655C11.058 60.8994 9.85425 57.2882 12.2618 56.0844L88.6999 6.73067C92.3111 4.32317 96.5243 4.32317 100.136 6.73067L177.176 56.0844C179.583 57.2882 178.379 60.8994 175.972 60.8994Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.183 163.82H74.8569V118.078C74.8569 106.642 83.8851 97.6138 95.3207 97.6138C106.756 97.6138 115.784 106.642 115.784 118.078V163.82H115.183Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185 183.08H4.4375V169.839C4.4375 166.228 6.845 163.82 10.4563 163.82H178.981C182.593 163.82 185 166.228 185 169.839V183.08Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.944 78.9556H148.887V145.764H166.944V78.9556Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5499 78.9556H22.4937V145.764H40.5499V78.9556Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5688 163.82H17.0769V148.773C17.0769 146.968 18.2807 145.764 20.0863 145.764H43.5594C45.365 145.764 46.5688 146.968 46.5688 148.773V163.82Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.361 163.82H142.869V148.773C142.869 146.968 144.072 145.764 145.878 145.764H169.351C171.157 145.764 172.361 146.968 172.361 148.773V163.82Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5594 78.9557H20.0863C18.2807 78.9557 17.0769 77.7519 17.0769 75.9463V60.8994H46.5688V75.9463C46.5688 77.7519 45.365 78.9557 43.5594 78.9557Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.351 78.9557H145.878C144.072 78.9557 142.869 77.7519 142.869 75.9463V60.8994H172.361V75.9463C172.361 77.7519 171.157 78.9557 169.351 78.9557Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.339 43.4448H95.9223H92.3111C89.9036 43.4448 87.4961 45.2504 87.4961 48.2598C87.4961 50.6673 89.3017 53.0748 92.3111 53.0748H96.5242",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.126 53.075C99.5335 53.075 101.941 54.8806 101.941 57.89C101.941 60.2975 100.135 62.705 97.126 62.705H88.0979",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9226 38.6299V43.4449",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9226 62.7051V67.5201",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7186 79.5575C109.344 79.5575 121.201 67.7009 121.201 53.075C121.201 38.4491 109.344 26.5925 94.7186 26.5925C80.0927 26.5925 68.2361 38.4491 68.2361 53.075C68.2361 67.7009 80.0927 79.5575 94.7186 79.5575Z",
    stroke: "#C2C2C2",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/markets.4fd96530ac7ccdd2ca7f18236c3bd452.svg";
export { ForwardRef as ReactComponent };